import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { spreadDangerousChildren } from "../../../utils/spreadDangerousChildren";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var CellRightSide = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    isReverse = _ref.isReverse,
    extraIcon = _ref.extraIcon,
    actionIcon = _ref.actionIcon,
    disabled = _ref.disabled,
    isRightSubtitleCrossedOut = _ref.isRightSubtitleCrossedOut,
    isCenter = _ref.isCenter;
  var isReverseCondition = isReverse && title && subtitle || !title && subtitle && actionIcon;
  var isSingleTitle = title && !subtitle && !actionIcon && !isCenter;
  var isSingleSubtitle = !title && subtitle && !actionIcon && !isReverse && !isCenter;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('cell-right-side', {
      'cell-right-side--reverse': isReverseCondition,
      'cell-right-side--row': (actionIcon || isCenter) && !subtitle,
      'cell-right-side--single-title': isSingleTitle && !isReverse,
      'cell-right-side--single-title-reverse': isSingleTitle && isReverse,
      'cell-right-side--single-subtitle': isSingleSubtitle,
      'cell-right-side--disabled': disabled
    }),
    "data-t-id": "components-CellRightSide"
  }, title && /*#__PURE__*/React.createElement("span", _extends({
    className: cn('cell-right-side__title', {
      'cell-right-side__title--disabled': disabled
    })
  }, spreadDangerousChildren(title))), subtitle && /*#__PURE__*/React.createElement("span", _extends({
    className: cn('cell-right-side__subtitle', {
      'cell-right-side__subtitle--crossed-out': isRightSubtitleCrossedOut,
      'cell-right-side__subtitle--disabled': disabled,
      'cell-right-side__subtitle--multi': !isSingleSubtitle && !isReverse,
      'cell-right-side__subtitle--multi-reverse': title && isReverse
    })
  }, spreadDangerousChildren(subtitle))), extraIcon, actionIcon && /*#__PURE__*/React.createElement("div", {
    className: cn('cell-right-side__icon')
  }, actionIcon));
});